import { format } from 'date-fns';
import moment from 'moment-timezone';
import { useCallback, useEffect, useId, useMemo } from 'react';

import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import CustomDateInput from 'src/sections/invoice_details/invoiceInfo/CustomDateInput';
import { getBgColor, getIcon } from 'src/utils/icons';
import { convertDate } from 'src/utils/transformation';

const DeliveryDate = () => {
  const { updateFormData, errors, receiptData, isInProgress } = useReceiptDetails();
  const formatDate = useMemo(
    () =>
      receiptData?.deliveryDateTime !== null
        ? format(convertDate(receiptData?.deliveryDateTime), 'LLL dd, yyyy').toString()
        : undefined,
    [receiptData?.deliveryDateTime]
  );
  const hasError = useMemo(
    () => !!errors.deliveryDateTime.length,
    [errors.deliveryDateTime.length]
  );
  const preventDefault = useCallback((e: any) => {
    e.preventDefault();
  }, []);

  const id = useId();

  useEffect(() => {
    document.getElementById(id)?.addEventListener('keyup', (e: any) => {
      updateFormData('_deliveryDateTime', e.target.value);
    });
    return document.getElementById(id)?.removeEventListener('keyup', (e) => {});
  }, [id, updateFormData]);

  const handleInputChange = useCallback(
    (date: Date | null) => {
      updateFormData('deliveryDateTime', date);
      if (date) {
        updateFormData('_deliveryDateTime', moment(date).format('MM/DD/YYYY'));
      }
    },
    [updateFormData]
  );

  return (
    <PopUp
      show={hasError}
      popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'left', vertical: 'center' }}
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper contents={errors.deliveryDateTime} type="Error" />
        </div>
      }
    >
      <div className={`p-1 ${getBgColor(errors.deliveryDateTime)} text-[13px]`}>
        <p className="font-bold pb-1 flex items-center whitespace-nowrap">
          Delivery Date{' '}
          <span className="inline-block px-2">{getIcon(errors.deliveryDateTime)}</span>
        </p>
        {isInProgress ? (
          <span onDragStart={preventDefault} onDragOver={preventDefault}>
            <CustomDateInput
              value={
                receiptData?.deliveryDateTime
                  ? convertDate(receiptData?.deliveryDateTime)
                  : undefined
              }
              valid={!hasError}
              id={id}
              onChange={handleInputChange}
            />
          </span>
        ) : (
          <p>{formatDate}</p>
        )}
      </div>
    </PopUp>
  );
};

export default DeliveryDate;
